<template>
    <div class="overlay">
        <business-models-modal ref="businessmodelsmodalref" />
        <div class="overlay_inner channel_list">
            <search-input
                    :show-label="false"
                    p-class="field search-field"
                    input-class="search clearable"
                    :input-placeholder="'Vyhledat kanál' | translate"
                    v-model="search"
            ></search-input>
            <select-box
                    v-if="showChannelSort"
                    id="channel-sort"
                    class="field sorting-field"
                    :omit-label="true"
                    v-model="channelSortValue"
                    :options="channelsSortOptions"
            ></select-box>
            <p class="note" v-translate>Seznam kanálů ve službě</p>
            <div id="responsiveTabsPopup" class="responsiveTabs r-tabs">
                <ul class="tabs r-tabs-nav">
                    <li v-for="group in groupsWithFilteredChannels" :key="group.id" :class="getActiveTabClass(group.id, false)">
                        <a v-if="group.channels.length > 0" @click.prevent.stop="activateTab(group.id, false)">
                            {{ group.name }} ({{ group.channels.length }})
                        </a>
                        <span v-if="group.channels.length === 0">{{ group.name }} ({{ group.channels.length }})</span>
                    </li>
                </ul>
                <div v-for="group in groupsWithFilteredChannels"
                     :key="group.id"
                     class="tabs_content"
                     v-show="isActiveTab(group.id, false)">
                    <ol>
                        <list-item-channel-basic-info
                                v-for="channel in group.channels"
                                :item="channel"
                                :key="channel.id"
                                @show-business-models="$refs.businessmodelsmodalref.showBusinessModels(arguments[0])"
                        ></list-item-channel-basic-info>
                    </ol>
                </div>
            </div>
            <a
					class="btn btn_action btn_close"
										:title="'Zavřít' | translate"
					@click.stop.prevent="emitClose"
					v-translate>Zavřít
			</a>
        </div>
    </div>
</template>

<script>
	import tabs from "@/components/mixins/tabs"
	import ListItemChannelBasicInfo from "@/components/common/ListItemChannelBasicInfo"
	import SearchInput from "@/components/common/SearchInput"
	import channelsSortOptions from "@/components/mixins/channels-sort-options"
	import {sortByKey} from "../../../../utils/helpers"
  import BusinessModelsModal from "../../../common/BusinessModelsModal.vue";

	export default {
		name: "ServiceChannelsPopup",
		components: { BusinessModelsModal, SearchInput, ListItemChannelBasicInfo},
		mixins: [tabs, channelsSortOptions],
		props: {
			popupData: Array,
			showChannelSort: {
				type: Boolean,
				default: () => false,
			},
		},
		data() {
			return {
				search: ''
			}
		},
		created() {
			this.activeTab = this.popupData[0]['id']
		},
		computed: {
			groupsWithFilteredChannels() {
				if (this.search === '') {
					let sorted = []
					this._.forEach(this.popupData, function (group) {
						sorted.push({
							'id': group['id'],
							'name': group['name'],
							'channels': this.getSortedChannels(group['channels'])
						})
					}.bind(this))

					return sorted
				} else {
					let sortedFilteredPopupData = []
					this._.forEach(this.popupData, function (group) {
						sortedFilteredPopupData.push({
							'id': group['id'],
							'name': group['name'],
							'channels': this.getFilteredChannels(group['channels'])
						})
					}.bind(this))

					return sortedFilteredPopupData
				}
			}
		},
		methods: {
			emitClose() {
				this.$emit('close')
			},
			getFilteredChannels(channels) {
				const filteredChannels = this._.filter(channels, function (channel) {
					return channel.name.search(new RegExp(this.search, 'i')) !== -1
				}.bind(this))

				return this.getSortedChannels(filteredChannels)
			},
			getSortedChannels(channels) {
				const sort = this.channelSortValue.split('-')
				const key = sort[0]
				const direction = sort[1]

				return sortByKey(channels, key, direction, key === 'name')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/servicesList/ServiceChannelsPopup.vue